import { observable, action } from 'mobx';

class ContractManageStore {
  @observable summaryInfoMap: Record<string, any> = {};

  @action
  setSummaryInfoMap(data: Record<string, any>) {
    this.summaryInfoMap = data;
  }
}

export default new ContractManageStore();
